import {
  GET_POSITION_HISTORY,
  CREATE_POSITION_HISTORY,
  DELETE_POSITION_HISTORY,
  GET_LATEST_POSITION_HISTORY
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_POSITION_HISTORY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/position_histories",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_POSITION_HISTORY]({ dispatch }, params) {
      let url = "/kanri/position_histories/position_history_create";
      const res = await dispatch("apiPost", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_POSITION_HISTORY]({ dispatch }, params) {
      let url = "/kanri/position_histories/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_LATEST_POSITION_HISTORY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/position_histories/get_latest",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
